const API_PATH = {
  refreshAccessToken: "/admin/token",
};

export default API_PATH;
